import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'loader-2', 'Loader2', [["path",{"d":"M12 3a9 9 0 1 0 9 9"}]]);